import { useCallback } from 'react';
import { useExpertProfileLazyQuery } from 'shared/hooks/api/expertProfile/expertProfile.generated';
import { useExpertProfileStore } from 'shared/hooks/stores/useExpertProfileStore';

export const useExpertProfileRefresh = () => {
  const [getExpertProfile, { loading }] = useExpertProfileLazyQuery({
    fetchPolicy: 'no-cache',
  });
  const loadExpertProfile = useExpertProfileStore((state) => state.loadExpertProfile);

  const refreshExpertProfile = useCallback(async () => {
    const res = await getExpertProfile();
    if (!res.data?.expertHubData) {
      throw new Error('Error occurred while updating the expert profile');
    }
    loadExpertProfile(res.data.expertHubData);
  }, [getExpertProfile]);

  return {
    refreshExpertProfile,
    loading,
  };
};
